"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLoginNonce = createLoginNonce;
exports.encryptLoginPayload = encryptLoginPayload;
var _cryptoJs = _interopRequireDefault(require("crypto-js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var KEY = _cryptoJs.default.enc.Utf8.parse('YxkjLoginPayldKy');
var IV = _cryptoJs.default.enc.Utf8.parse('YxkjLoginPayldIv');
function createLoginNonce() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}
function encryptLoginPayload(payload) {
  var plainText = JSON.stringify(payload);
  var encrypted = _cryptoJs.default.AES.encrypt(plainText, KEY, {
    iv: IV,
    mode: _cryptoJs.default.mode.CBC,
    padding: _cryptoJs.default.pad.Pkcs7
  });
  return encrypted.ciphertext.toString(_cryptoJs.default.enc.Base64);
}